import Marquee from "react-fast-marquee";
import { IMAGES } from "../../data/site";

const POINTS = [
  {
    no: "01",
    title: "%100 Dana Eti",
    desc: "Köftelerimizde yalnızca %100 dana eti kullanılır. Katkısız, gerçek.",
  },
  {
    no: "02",
    title: "Günlük Taze Malzeme",
    desc: "Sebzeler her sabah gelir, soslarımız her gün taze hazırlanır.",
  },
  {
    no: "03",
    title: "Hızlı ve Uygun Fiyatlı",
    desc: "Sıcak, hızlı servis — şubede gel-al ya da kapına paket servis.",
  },
];

export const WhyUs = () => {
  return (
    <section id="neden-biz" data-testid="why-us-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 md:grid-cols-2">
        <div className="border-y-2 border-[#1A1A1A] md:border-r-2 md:border-y-0">
          <img
            data-testid="why-us-image"
            src={IMAGES.whyUs}
            alt="Deny's çift katlı burger, patates kızartması ve Pepsi"
            className="h-full max-h-[80vh] w-full object-cover object-top md:max-h-none"
            loading="lazy"
          />
        </div>
        <div className="px-4 py-16 md:px-12 md:py-24">
          <p className="font-script text-2xl text-[#E63946] md:text-3xl">
            Neden Deny'S?
          </p>
          <h2 className="mt-2 text-4xl font-black uppercase tracking-tighter text-[#1A1A1A] sm:text-5xl">
            İyi yemek,
            <br />
            iyi hissettirir.
          </h2>
          <div className="mt-10 space-y-8">
            {POINTS.map((p) => (
              <div
                key={p.no}
                data-testid={`why-us-point-${p.no}`}
                className="flex items-start gap-5"
              >
                <span className="text-3xl font-black tracking-tighter text-[#E63946]">
                  {p.no}
                </span>
                <div>
                  <h3 className="text-lg font-black uppercase tracking-tight text-[#1A1A1A]">
                    {p.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium text-[#4A4A4A]">
                    {p.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        data-testid="slogan-marquee"
        className="border-y-2 border-[#1A1A1A] bg-[#E63946] py-3"
      >
        <Marquee speed={50} gradient={false}>
          <span className="mx-6 text-lg font-black uppercase tracking-widest text-white">
            Lezzet Her Zaman Kazanır • İyi Yemek İyi Hissettirir • Gerçek Burger
            Gerçek Lezzet •
          </span>
          <span className="mx-6 text-lg font-black uppercase tracking-widest text-white">
            Lezzet Her Zaman Kazanır • İyi Yemek İyi Hissettirir • Gerçek Burger
            Gerçek Lezzet •
          </span>
        </Marquee>
      </div>
    </section>
  );
};
